export const primaryNavigationWidth = "260px";
export const secondaryNavigationWidth = "258px";
export const entryInputHeight = "40px";
export const userProfileImgWidth = "35px";
export const secondaryProfileImgWidth = "122px";
export const secondaryProfileImgHeight = "122px";
export const primaryNavHeadingHeight = "70px";
export const customCheckBoxDimension = "18px";
export const tooltipModalArrowSize = 15;
export const eyeIconWidth = "16px";

// Equal to 12px
export const textExtraSmallVar = "0.75rem";

// Equal to 14px
export const textSmallVar = "0.875rem";

// Equal to 16px
export const textSemiSmallVar = "1rem";

// Equal to 18px
export const textMediumVar = "1.125rem";

// Equal to 20px
export const textSemiLargeVar = "1.125rem";

// Equal to 22px
export const textLargeVar = "1.375rem";

// Equal to 26px
export const textUltraLargeVar = "1.5rem";

export const closeIconWidth = "25px";

// Src/styles/genericSidebar.scss has $right-side-panel-width, use same width here as well
export const RightSidePanelWidth = "400px";
export const RightSidePanelHeaderMinHeight = "56px";

export const SelectDropdownMaxHeight = 220;
